module.exports = __webpack_public_path__ + "media/images/athletes/2791-e977c98d635efd7c2e1686ca32263ad7.png";